<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Konfigurasi Sistem"
        class="card-wrapper"
        >

        <v-card>
        <v-card-title>
            
            <v-text-field
            v-model="search"
            class="esign-table-search"
            prepend-inner-icon="mdi-magnify"
            label="Cari Konfigurasi berdasarkan Nama"
            outlined
            dense
            clearable
            single-line
            hide-details
          ></v-text-field>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="pengaturans"
            :search="search"
            :loading="isLoading"
            loading-text="Memuat data..."
            no-data-text="Data Pengaturan tidak ditemukan"
            no-results-text="Data Pengaturan tidak ditemukan"
            hide-default-footer
        >
          <template v-slot:footer="{ props, on }">
            <esign-table-footer
            :pagination="props.pagination"
            :options="props.options"
            @update:options="on['update:options']"
            />
          </template>
          <template v-slot:item.aksi="{ item }">
            <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="orange" dark @click="editItem(item)"><v-icon small class="mr-1"> mdi-pencil </v-icon>Ubah</v-btn>
          </template>
        </v-data-table>
        </v-card>
        
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Tutup</v-btn>
        </v-snackbar>
        </material-card>
    </v-container>
    
  </template>

<script>
import { apiServer } from "../../setup-axios";

export default {
  data () {
    return {
      pengaturans: [],
      search: '',
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      currentPeran: "",
      isLoading: true,
      dialog: false,
      totalData: 0,
      headers: [
        {
          text: 'Nama Pengaturan',
          align: 'start',
          sortable: false,
          value: 'nama',
        },
        { text: 'Nama Variabel', 
          sortable: false,
          value: 'variable' 
        },
        { text: 'Rincian Pengaturan', 
          sortable: false,
          value: 'detail' 
        },
        { text: 'Isi Variabel', 
          sortable: false,
          value: 'value' 
        },
        { text: 'Aksi',
          sortable: false,
          value: 'aksi' },
      ],
    }
  },
  created() {
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    console.log("loading")
    this.getData();
  },
  methods: {
    getData() {
      this.isLoading = true;
      console.log(this.isLoading);
      apiServer
        .get("/pengaturan/all")
        .then(response => {
          this.pengaturans = response.data.data;
          this.isLoading = false;
          console.log("loaded")
          console.log(this.pengaturans)
          this.currentPeran = localStorage.getItem("currentPeran")
          this.totalData = response.data.total
          if(localStorage.getItem("updateSuccess") != null) {
            this.showSnackbar("orange", localStorage.getItem("updateSuccess"));
            this.close()
            localStorage.removeItem("updateSuccess")
          }
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    editItem(item){
      console.log(item)
      this.$router.push('/pengaturan/ubah/' + item.id);
    },
  }
}
</script>